import View from "./user-info.view";
import Presenter from "./user-info.presenter";
import { ConnectComponent2 } from "util";

const states = [
  {
    name: "app.registration.user.info",
    url: "/:userUuid",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/user/info/index.js